<template>
  <div class="mt-4">
    <p class="text-body-2 text-grey-body mb-16">{{ statusMessage }}</p>
    <div class="flex flex-wrap gap-4">
      <cpr-badge :active="isBadgeComplete('cpr_certified')" :width="badgeSize" :height="badgeSize" :hasSimpleLabel="true" />
      <first-aid-badge
        :active="isBadgeComplete('first_aid_training')"
        :width="badgeSize"
        :height="badgeSize"
        :hasSimpleLabel="true"
      />
    </div>
  </div>
</template>

<script lang="ts">
import CprBadge from '@/graphics/badges/CPRBadge.vue';
import FirstAidBadge from '@/graphics/badges/FirstAidBadge.vue';

interface Badge {
  name: 'cpr_certified' | 'first_aid_training';
  status: 'not_run' | 'expired' | 'pending' | 'complete' | 'review_recommended' | 'ineligible';
  completedAt: string | null;
  expiresAt: string | null;
  __typename: 'Badge';
}

export default {
  name: 'ProfileCertifications',
  components: {
    CprBadge,
    FirstAidBadge,
  },
  props: {
    badges: {
      type: Array as () => Badge[],
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      badgeSize: 60,
    };
  },
  computed: {
    statusMessage(): string {
      return this.badges.length > 0 ? 'These are self-reported, not verified' : 'Not reported';
    },
  },
  methods: {
    isBadgeComplete(name: Badge['name']): boolean {
      return this.badges.some((badge) => badge.name === name && badge.status === 'complete');
    },
  },
};
</script>
